import { sha256 } from 'js-sha256';

/**
 * This function first extracts the BIN (first 6 digits) and the rest of the card number.
 * It then hashes the rest of the card number and takes the first 14 characters of the hash.
 * Finally, it concatenates the BIN and the hash to get the desired output.
 *
 * This is the desired output with example according to the Kount documentation:
 * https://developer.kount.com/hc/en-us/articles/11301589488404-Payment-Encryption-PENC-Options
 *
 * @param {string} creditCardNumber - The credit card number to be hashed.
 * @returns {string} - The hashed credit card number.
 * @throws {Error} - Throws an error if KOUNT_KHASH_KEY is not defined.
 */
export const hashCreditCard = (creditCardNumber: string): string => {
  if (!process.env.KOUNT_KHASH_KEY) {
    throw new Error('KOUNT_KHASH_KEY is not defined');
  }

  const bin = creditCardNumber.slice(0, 6);
  const restOfCardNumber = creditCardNumber.slice(6);
  const lastDigits = creditCardNumber.slice(-4); // get last 4 digits of the card number
  const hash = sha256
    .hmac(process.env.KOUNT_KHASH_KEY, restOfCardNumber)
    .slice(0, 9); // get only first 9 characters of the hash
  const maskedHash = 'X'.repeat(hash.length); // replace hash characters with 'X'
  return (bin + maskedHash + lastDigits).replace(/\s+/g, '');
};
